import { VODCSSModules } from 'shared/utils/wix-connect';
import { FormattedMessage } from 'react-intl';

import styles from './bottom-buttons.styl';
import translations from '../translations';
import { GenericButton } from 'shared/components/button/button';
import ElementSwitcher from 'shared/components/element-switcher/element-switcher';
import Icon from 'shared/components/icon/icon';


export const BottomButton = VODCSSModules(styles)(
  props => (
    <GenericButton {..._.omit(props, 'dataHook')}
                   styleName="bottom-button" />
  )
);

export class SubscribeBottomButton extends React.Component {
  static propTypes = {
    maxWidth: React.PropTypes.number,
    forceShortText: React.PropTypes.bool,
    children: React.PropTypes.any,
  };

  get icon() {
    return (
      <Icon name="paid"
            className={styles['paid-icon']} />
    );
  }

  get shortLabel() {
    return (
      <ElementSwitcher maxWidth={this.props.maxWidth}>
        <span>
          {this.icon}
          <FormattedMessage {...translations.subscribeShortText} />
        </span>
        {this.icon}
      </ElementSwitcher>
    );
  }

  get content() {
    const { maxWidth, children, forceShortText } = this.props;
    if (forceShortText) {
      return this.shortLabel;
    }

    return (
      <ElementSwitcher maxWidth={maxWidth}>
        {children}
        {this.shortLabel}
      </ElementSwitcher>
    );
  }

  render() {
    const buttonProps = _.omit(this.props, 'maxWidth', 'dispatch', 'forceShortText');

    return (
      <BottomButton {...buttonProps}>
        {this.content}
      </BottomButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/mobile/three-rows-widget/buttons/bottom-buttons.js